import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.function.name";

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
// Turn the form state into an object of key value pairs to submit to the server
// - Apply field-level 'transformOnSubmit' transformations
// - Remove fields that should not be included
// - Apply the form-level 'transform' transformations
export default (function (_ref) {
  var fields = _ref.fields,
      transform = _ref.transform;
  return transform(fields.map(function (field) {
    console.log('Field', field.toJS());
    var value = field.submitUnmaskedValue ? field.unmaskedValue : field.value;
    return field.merge({
      value: field.transformOnSubmit ? field.transformOnSubmit({
        value: value,
        fields: fields
      }) : value
    });
  }).filter(function (field) {
    return field.includeInSubmit;
  }).reduce(function (payload, field) {
    var name = field.name || field.fieldId;

    if (payload[name]) {
      if (!Array.isArray(payload[name])) {
        payload[name] = [payload[name]];
      }

      payload[name].push(field.value);
    } else {
      payload[name] = field.value;
    }

    return payload;
  }, {}));
});